<template>
    <div class="main-sidebar">
        <b-navbar class="responsive-sidebar">
            <b-navbar-toggle target="sidenav_id" class="sidenav-toggle"></b-navbar-toggle>
            <b-collapse is-nav id="sidenav_id" ref="sidenav_id">
                <b-navbar-nav v-on:click="hideNavigation">
                    <b-nav-item to="dashboard">
                        <i class="material-icons md-24">dashboard</i> Dashboard
                    </b-nav-item >
                    <b-nav-item  v-if="hasInvoiceReviewClaim" to="/invoices">
                        <i class="material-icons md-24">description</i> {{ $t('sidebar.allInvoices') }}
                    </b-nav-item >
                    <!-- <b-nav-item  v-if="hasInvoiceCreateClaim" to="/register-invoice">
                        <i class="material-icons md-24">create</i> {{ $t('sidebar.registerInvoice') }}
                    </b-nav-item > -->
                    <b-nav-item  v-if="hasGroupSettlementCreateClaim" to="/group-settlement">
                        <i class="material-icons md-24">next_week</i> {{ $t('sidebar.groupSettlement') }}
                    </b-nav-item>
                    <b-nav-item to="/user-administration">
                        <i class="material-icons md-24">supervisor_account</i> {{ $t('sidebar.userAdministration') }}
                    </b-nav-item>
                    <b-nav-item  v-if="hasUserCreateClaim" to="/user-registration">
                        <i class="material-icons md-24">business</i> {{ $t('sidebar.userRegistration') }}
                    </b-nav-item>
                    <b-nav-item to="/reported-issues">
                        <i class="material-icons md-24">warning</i> {{ $t('sidebar.reportedIssues') }}
                    </b-nav-item>                        
                    <b-nav-item  v-if="hasInvoiceCreateClaim && isTestEnvironment" to="/settle-invoice">
                        <i class="material-icons md-24">monetization_on</i>{{ $t('sidebar.invoiceSettlement') }} <b-badge variant="success">Test</b-badge>
                    </b-nav-item>
                    <b-nav-item  v-if="hasAdminClaim" to="/intervention">
                        <i class="material-icons md-24">build</i>{{ $t('sidebar.intervention') }} <b-badge variant="warning">Admin</b-badge>
                    </b-nav-item>                    
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
        <transition name="collapse">
            <div v-if="showCollapse">
                <nav class="sidebar">
                    <ol>
                        <li>
                            <router-link to="/dashboard" exact><i class="material-icons md-24">dashboard</i><span>Dashboard</span></router-link>
                        </li>
                        <li v-if="hasInvoiceReviewClaim">
                            <router-link to="/invoices"><i class="material-icons md-24">description</i><span>{{ $t('sidebar.allInvoices') }}</span></router-link>
                        </li>
                        <!-- <li v-if="hasInvoiceCreateClaim">
                            <router-link to="/register-invoice"><i class="material-icons md-24">create</i><span>{{ $t('sidebar.registerInvoice') }}</span></router-link>
                        </li> -->
                        <li v-if="hasGroupSettlementCreateClaim || hasInvoiceReviewAllClaim">
                            <router-link to="/group-settlement"><i class="material-icons md-24">next_week</i><span>{{ $t('sidebar.groupSettlement') }}</span></router-link>
                        </li>
                        <li v-if="hasAdministrativePrivileges">
                            <router-link to="/user-administration"><i class="material-icons md-24">supervisor_account</i><span>{{ $t('sidebar.userAdministration') }}</span></router-link>
                        </li>
                        <li v-if="hasUserCreateClaim">
                            <router-link to="/user-registration"><i class="material-icons md-24">business</i><span>{{ $t('sidebar.userRegistration') }}</span></router-link>
                        </li>
                        <li>
                            <router-link to="/reported-issues"><i class="material-icons md-24">warning</i><span>{{ $t('sidebar.reportedIssues') }}</span></router-link>
                        </li>
                        <li v-if="hasInvoiceCreateClaim && isTestEnvironment">
                            <router-link to="/settle-invoice">
                                <i class="material-icons md-24">monetization_on</i><span>{{ $t('sidebar.invoiceSettlement') }} <b-badge variant="success">Test</b-badge></span>
                            </router-link>
                        </li>
                        <li v-if="hasAdminClaim">
                            <router-link to="/intervention">
                                <i class="material-icons md-24">build</i><span>{{ $t('sidebar.intervention') }} <b-badge variant="warning">Admin</b-badge></span>
                            </router-link>
                        </li>                        
                    </ol>
                    <b-row class="treasury-logo ml-2 text-center" align-v="end">
                        <b-col cols="*">
                            <img src="~@/assets/images/grb.svg">
                        </b-col>
                        <b-col cols="*">
                            <div class="pb-2">
                                <label>РЕПУБЛИКА СРБИЈА</label>
                                <label>МИНИСТАРСТВО ФИНАНСИЈА</label>
                                <label style="font-weight: 800">УПРАВА ЗА ТРЕЗОР</label>
                            </div>
                        </b-col>
                    </b-row>
                </nav>
            </div>
            <div v-else>
                <nav class="sidebar-collapsed">
                    <ol>
                        <li>
                            <router-link to="/dashboard" exact v-b-tooltip.hover.right title="Dashboard"><i class="material-icons md-24">dashboard</i></router-link>
                        </li>
                        <li v-if="hasInvoiceReviewClaim">
                            <router-link to="/invoices" v-b-tooltip.hover.right="$t('sidebar.allInvoices')"><i class="material-icons md-24">description</i></router-link>
                        </li>
                        <!-- <li v-if="hasInvoiceCreateClaim">
                            <router-link to="/register-invoice" v-b-tooltip.hover.right="$t('sidebar.registerInvoice')"><i class="material-icons md-24">create</i></router-link>
                        </li> -->
                        <li v-if="hasGroupSettlementCreateClaim || hasInvoiceReviewAllClaim">
                            <router-link to="/group-settlement" v-b-tooltip.hover.right="$t('sidebar.groupSettlement')"><i class="material-icons md-24">next_week</i></router-link>
                        </li>
                        <li v-if="hasAdministrativePrivileges">
                            <router-link to="/user-administration" v-b-tooltip.hover.right="$t('sidebar.userAdministration')"><i class="material-icons md-24">supervisor_account</i></router-link>
                        </li>
                        <li v-if="hasUserCreateClaim">
                            <router-link to="/user-registration" v-b-tooltip.hover.right="$t('sidebar.userRegistration')"><i class="material-icons md-24">business</i></router-link>
                        </li>
                        <li>
                            <router-link to="/reported-issues" v-b-tooltip.hover.right="$t('sidebar.reportedIssues')"><i class="material-icons md-24">warning</i></router-link>
                        </li>                             
                        <li v-if="hasInvoiceCreateClaim && isTestEnvironment">
                            <router-link to="/settle-invoice" v-b-tooltip.hover.right title="$t('sidebar.invoiceSettlement')"><i class="material-icons">monetization_on</i></router-link>
                        </li>
                        <li v-if="hasAdminClaim">
                            <router-link to="/intervention" v-b-tooltip.hover.right title="$t('sidebar.intervention')"><i class="material-icons">build</i></router-link>
                        </li>
                    </ol>
                    <b-row class="treasury-logo ml-2 text-center" align-v="end">
                        <b-col cols="*">
                            <img src="~@/assets/images/grb.svg">
                        </b-col>
                    </b-row>
                </nav>
            </div>
        </transition>
        <b-btn @click="toggle" :class="{'button-class':showCollapse, 'button-class-collapsed':!showCollapse}" id="collapse-button">
            <i class="material-icons md-24">{{buttonLabel}}</i>
        </b-btn>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { hasAdminClaim, hasUserCreateClaim, hasLocalUserCreateClaim, hasInvoiceCreateClaim, hasInvoiceReviewClaim, hasInvoiceReviewAllClaim, hasGroupSettlementCreateClaim } from '@/router/auth'
  import { getUser, getSidebarToggleInfo, setSidebarToggleInfo } from '@/utils/cookie'

  function getCurrentSidebarToggleInfo (self) {
    var key = getUser()
    var sidebarToggleInfo = getSidebarToggleInfo(key)
    // if user has not set token, toggle value should be true
    if (sidebarToggleInfo == null) {
      sidebarToggleInfo = true
    }
    return sidebarToggleInfo
  }

  function setCurrentSidebarToggleInfo (self, sidebarInfo) {
    var key = getUser()
    setSidebarToggleInfo(key, sidebarInfo)
  }

  export default {
    data () {
      return {
        isTestEnvironment: Vue.$config.test_env,
        hasAdminClaim: false,
        hasUserCreateClaim: false,
        hasLocalUserCreateClaim: false,
        hasInvoiceCreateClaim: false,
        hasInvoiceReviewClaim: false,
        hasGroupSettlementCreateClaim: false,
        hasInvoiceReviewAllClaim: false,
        showCollapse: true
      }
    },
    computed: {
      hasAdministrativePrivileges () {
        return this.hasUserCreateClaim || this.hasLocalUserCreateClaim
      },
      buttonLabel () {
        return this.showCollapse ? 'keyboard_arrow_left' : 'keyboard_arrow_right'
      }
    },
    created () {
      this.hasAdminClaim = hasAdminClaim()
      this.hasUserCreateClaim = hasUserCreateClaim()
      this.hasLocalUserCreateClaim = hasLocalUserCreateClaim()
      this.hasInvoiceCreateClaim = hasInvoiceCreateClaim()
      this.hasInvoiceReviewClaim = hasInvoiceReviewClaim() || hasInvoiceReviewAllClaim()
      this.hasGroupSettlementCreateClaim = hasGroupSettlementCreateClaim()
      this.hasInvoiceReviewAllClaim = hasInvoiceReviewAllClaim()
      this.showCollapse = getCurrentSidebarToggleInfo(this)
    },
    methods: {
      hideNavigation () {
        this.$root.$emit('bv::toggle::collapse', this.$refs.sidenav_id)
      },
      toggle () {
        this.showCollapse = !this.showCollapse
        setCurrentSidebarToggleInfo(this, this.showCollapse)
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
    @import '~@/assets/scss/variables.scss';

    nav > ol {
        list-style: none;
        margin: 10px 0 20px;
        padding: 0;
        > li {
            margin: 2px 8px;
            > a {
                font-weight: 600;
                font-size: 11pt;
                color: transparentize($font-color-dark, .3);
                background-color: $background-color-dark;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: left;
                height: 64px;
                max-width: 250px;
                border: 1px solid transparentize($background-color-accent, .7);
                &:hover {
                    color: $primary-color-accent;
                    text-decoration: none;
                }
                &.active, &:focus {
                    color: $font-color-light;
                    text-decoration: none;
                    background-color: $primary-color-accent;
                }
                span {
                    text-align: center;
                    flex-grow: 1;
                }
                i {
                    margin-right: 0.25rem;
                    margin-left: 0.25rem
                }
            }
        }
    }

    #sidenav_id {
        border-bottom: 1px solid transparentize($background-color-accent, .7);

    .collapsed > .when-opened,
        :not(.collapsed) > .when-closed {
        display: none;
        }
    }

    #sidenav_id > ul {
        list-style: none;
        margin: 10px 0 10px;
        padding: 0;
        > li {
            margin: 8px;
            height: 45px;

            > a {
                font-weight: 600;
                font-size: 11pt;
                color: transparentize($font-color-dark, .3);
                background-color: $background-color-dark;
                display: block;
                line-height: 45px;
                text-align: center;
                border: 1px solid transparentize($background-color-accent, .7);

                &:hover {
                    color: $primary-color-accent;
                    text-decoration: none;
                }
                &.active, &:focus {
                    color: $font-color-light;
                    text-decoration: none;
                    background-color: $primary-color-accent;
                }
            }
        }
    }

    .collapse-enter-active,
    .collapse-enter-to,
    .collapse-leave-active,
    .collapse-leave-to {
    transition: .5s ease-in-out;
    }

    @media (max-width: 800px) {
        .responsive-sidebar {
            display: block !important;
        }

        .sidebar {
            display:none !important;
        }

        .sidebar-collapsed {
            display:none !important;
        }

        .button-class{
            display:none !important;

        }
        .button-class-collapsed{
            display:none !important;
        }
    }

    .responsive-sidebar {
        display: none;
    }

    .sidebar-collapsed {
        width: 70px;
    }

    .main-sidebar {
        img {
            width: 250px;
            margin-top: 20%;
        }
    }

    .treasury-logo {
        height: 75px;
        margin-top: 75px;

        img {
            width: 55px !important;
            height: 75px !important;
        }
        label {
            display: block;
            font-size: 8pt;
            font-weight: 600;
            margin: 0px;
        }
    }
    #collapse-button {
        position: fixed;
        bottom: 2rem;
    }
    .button-class{
        width: 250px;
        margin-top: 15px;
        margin-left: 10px;
        border: none;
        color:rgba(0,0,0,7);
        background-color: $background-color-dark;
        font-weight: 600;
        font-size: 11pt;

        &:hover {
            color: $primary-color-accent;
            text-decoration: none;
        }
    }
    .button-class-collapsed{
        width: 55px;
        margin-top: 15px;
        margin-left: 10px;
        // position:relative;
        // top: 50px;
    }
    .material-icons.md-24 {
        font-size: 24px;
        vertical-align: middle;
    }

</style>



// WEBPACK FOOTER //
// SideNav.vue?f8d4a9ae